




import Vue from 'vue';
import UserCreateForm from '@/common/components/users/UserCreateForm.vue';
import { UserType } from '@/common/components/users/users.types';

export default Vue.extend({
  props: {
    userPermissions: {
      type: Array,
      required: false,
    },
  },
  data() {
    return {
      title: 'Create user',
      UserType,
    };
  },
  created() {
    if (this.title) {
      document.title = this.title;
    }
  },
  components: {
    UserCreateForm,
  },
});
